import { httpGET, httpPOST, json } from './utils.js';
import { userTermIds, selectTerm } from '../selectors/terms';
import { fetchSectionsForTerm, getSection } from 'actions/section';
import { fetchContentForSection } from 'actions/content';
import { ACTIONS, ICONS } from '../const';
import { push } from 'react-router-redux';
import { newNotification } from 'actions/notifications.js';

export function setCurrentTerm(id) {
    return async (dispatch, getState) => {
        const term = await dispatch(fetchTerm(id));
        if (term) {
            await dispatch(fetchSectionsForTerm(term));

            if (term.id !== id) {
                dispatch({
                    type: ACTIONS.CURRENT_TERM,
                    payload: id,
                });
            }
        }
    };
}

export function fetchTerm(id) {
    return (dispatch, getState) => {
        const {
            terms: { terms },
        } = getState();
        if (terms[id]) {
            return Promise.resolve(terms[id]);
        }
        return httpGET(`/api/v3/term/${id}/`)
            .then(json)
            .then(
                data => {
                    dispatch({
                        type: ACTIONS.SYNC_TERM,
                        payload: data,
                    });
                    return data;
                },
                () => dispatch(push('/'))
            );
    };
}

export function loadTerms() {
    return (dispatch, getState) => {
        const state = getState();
        const terms = userTermIds(state).map(id => {
            const term = selectTerm(state, id);
            if (!term) {
                return dispatch(fetchTerm(id));
            }
            return Promise.resolve(term);
        });

        return Promise.all(terms);
    };
}

export function copyMaterials(data) {
    return dispatch => {
        const { fromSectionId, toSectionIds } = data;
        const {
            includeLinks: include_class_materials,
            includeTags: include_tags,
        } = data;

        const update = toSectionId => {
            const postOptions = {
                headers: {
                    Accept: '*/*',
                },
                formData: {
                    copy_to: `${window.location.protocol}://${window.location.host}/api/section/${toSectionId}/`,
                    include_class_materials,
                    include_tags,
                },
            };

            return httpPOST(
                `/api/section/${fromSectionId}/copy/`,
                null,
                postOptions
            )
                .then(() => {
                    dispatch(getSection(toSectionId, 'force'));
                    dispatch(fetchContentForSection({ id: toSectionId }));
                })
                .catch(() => {
                    const errorText = `Could not copy materials to section ${toSectionId}`;
                    dispatch(
                        newNotification('Error', errorText, {
                            icon: ICONS.FAIL,
                            dismissable: true,
                        })
                    );
                    throw new Error(errorText);
                });
        };

        return Promise.all(toSectionIds.map(update)).then(() =>
            dispatch(
                newNotification(
                    'Materials copied',
                    'Successfully copied course materials',
                    { icon: ICONS.SUCCESS }
                )
            )
        );
    };
}



// WEBPACK FOOTER //
// ./src/actions/terms.js